// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"3b1d7bf9","548":"c3ea440a","961":"16db6a3f"}[chunkId] + ".chunk.js";
};